import { render, staticRenderFns } from "./transaction-payment-purpose.vue?vue&type=template&id=01716d64&"
import script from "./transaction-payment-purpose.vue?vue&type=script&lang=js&"
export * from "./transaction-payment-purpose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports